import { initI18n } from '@wix/wix-i18n-config';
import { join } from 'path';
import { readFileSync } from 'fs';

const readMessages = async (locale: string): Promise<Record<string, string>> => {
  const path = `statics/assets/locales/messages_${locale}.json`;
  const file = join(__dirname, path);
  return JSON.parse(readFileSync(file, 'utf8'));
};

const readMessagesSafe = async (locale: string): Promise<Record<string, string> | undefined> => {
  try {
    return await readMessages(locale);
  } catch {
    return undefined;
  }
};

const getI18n = () => {
  const isDev = process.env.NODE_ENV === 'development';
  const locale = window.__LOCALE__;
  const messages = isDev ? require(`../assets/locales/messages_${locale}.json`) : window.__MESSAGES__;
  return initI18n({ messages, locale });
};

export const localeUtils = {
  readMessages,
  readMessagesSafe,
  getI18n,
};
